import { IVideoTextureEngine } from './IVideoTextureEngine';
import { NativeVideoTextureEngine } from './NativeVideoTextureEngine';
import { SyncVideoEngine } from './SyncVideoEngine';
import { CanvasVideoEngine } from './CanvasVideoEngine';

export class VideoEngineFactory {
  static createEngine(video: HTMLVideoElement): IVideoTextureEngine {
    // 1. Detect Environment
    const ua = navigator.userAgent;
    
    // Check for iPad (which masquerades as Mac on iOS 13+)
    const isIPad = (/Macintosh/.test(ua) && navigator.maxTouchPoints > 1) || /iPad/.test(ua);
    
    // Check for iPhone specifically (exclude iPad)
    const isIPhone = /iPhone|iPod/.test(ua) && !isIPad && !(window as any).MSStream;
    
    // Check for rVFC support
    const supportsRVFC = 'requestVideoFrameCallback' in video;

    console.log('[VideoEngineFactory] Detection:', {
      isIPad,
      isIPhone,
      supportsRVFC,
      userAgent: ua
    });

    // 2. Select Strategy

    // Every device gets the standard engine: Three.js copies the playing
    // <video> into the texture each frame. That is what the October 2026
    // device test did on two iPhones and an iPad, and what the iPad has always
    // used here. The two iPhone-only engines below date from December 2025,
    // before the sphere was switched off on iPhone, and have not run on a
    // device since — so they are opt-in, for diagnosis only:
    //   ?engine=sync    texture updates driven by requestVideoFrameCallback
    //   ?engine=canvas  video drawn to a 2D canvas, canvas used as the texture
    const requested = new URLSearchParams(window.location.search).get('engine');
    if (requested === 'sync' && supportsRVFC) {
      console.log('[VideoEngineFactory] Selected: SyncVideoEngine (?engine=sync)');
      return new SyncVideoEngine(video);
    }
    if (requested === 'canvas') {
      console.log('[VideoEngineFactory] Selected: CanvasVideoEngine (?engine=canvas)');
      return new CanvasVideoEngine(video);
    }

    console.log('[VideoEngineFactory] Selected: NativeVideoTextureEngine (Standard)');
    return new NativeVideoTextureEngine(video);
  }
}
